import { useState, useEffect } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { RiDeleteBinLine } from 'react-icons/ri';

type Props = {
    id: number;
    campaignRequestId?: number | null;
    onDelete: (id: number, campaignRequestId?: number | null) => void;
};

const DeleteMessageModal = ({ id, campaignRequestId, onDelete }: Props) => {
    const [modalOpen, setModalOpen] = useState(false);

    const closeModal = () => {
        setModalOpen(false);
    };

    const handleDelete = () => {
        onDelete(id, campaignRequestId);
        closeModal();
    };

    useEffect(() => {
        const keyHandler = ({ keyCode }: KeyboardEvent) => {
            if (keyCode === 27) closeModal();
        };
        document.addEventListener('keydown', keyHandler);
        return () => document.removeEventListener('keydown', keyHandler);
    }, []);

    return (
        <>
            <button onClick={() => setModalOpen(!modalOpen)}>
                <RiDeleteBinLine color='red' />
            </button>

            {modalOpen && (
                <div
                    className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75'
                    onClick={closeModal}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className='relative w-full max-w-xl rounded-lg bg-white shadow-lg'
                    >
                        <button
                            className='text-gray-600 hover:text-gray-900 absolute right-4 top-4'
                            onClick={closeModal}
                        >
                            <RxCross2 />
                        </button>
                        <div className='p-8'>
                            <div className='mb-4'>
                                <h2 className='mb-[30px] text-[22px] font-bold'>
                                    Delete Message?
                                </h2>
                            </div>

                            <p className='mb-[30px]'>
                                Are you sure you want to delete this message?
                            </p>

                            <div className='flex justify-start space-x-4'>
                                <button
                                    onClick={closeModal}
                                    className='rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-black hover:bg-black hover:text-white'
                                >
                                    No, Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    className='rounded-full bg-warning px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase text-black transition-colors duration-500 hover:bg-yellow'
                                >
                                    Yes, Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default DeleteMessageModal;
